

export const frontMatter = {
	'SPDX-FileCopyrightText': '2024 The Refinery Authors',
	'SPDX-License-Identifier': 'EPL-2.0',
	sidebar_position: 1,
	sidebar_label: 'CLI'
};
export const contentTitle = 'Command-line interface';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-versioned-docs-version-0-3-0-learn-docker-cli-md-4b2.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import LockIcon from '@material-icons/svg/svg/lock/baseline.svg';
export const toc = [{
  "value": "The <code>generate</code> subcommand",
  "id": "generate",
  "level": 2
}, {
  "value": "<code>-output</code>, <code>-o</code>",
  "id": "generate-output",
  "level": 3
}, {
  "value": "<code>-random-seed</code>, <code>-r</code>",
  "id": "generate-random-seed",
  "level": 3
}, {
  "value": "<code>-scope</code>, <code>-s</code>",
  "id": "generate-scope",
  "level": 3
}, {
  "value": "<code>-scope-override</code>, <code>-S</code>",
  "id": "generate-scope-override",
  "level": 3
}, {
  "value": "<code>-solution-number</code>, <code>-n</code>",
  "id": "generate-solution-number",
  "level": 3
}, {
  "value": "The <code>check</code> subcommand",
  "id": "check",
  "level": 2
}, {
  "value": "<code>-concretize</code>, <code>-k</code>",
  "id": "check-concretize",
  "level": 3
}, {
  "value": "The <code>concretize</code> subcommand",
  "id": "concretize",
  "level": 2
}, {
  "value": "<code>-output</code>, <code>-o</code>",
  "id": "concretize-output",
  "level": 3
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    header: "header",
    li: "li",
    p: "p",
    pre: "pre",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "command-line-interface",
        children: "Command-line interface"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["You can run Refinery as a command-line applications via our ", _jsx(_components.a, {
        href: "https://github.com/graphs4value/refinery/pkgs/container/refinery-cli",
        children: "Docker container"
      }), " on either ", _jsx(_components.code, {
        children: "amd64"
      }), " or ", _jsx(_components.code, {
        children: "arm64"
      }), " machines:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-shell",
        children: "docker run --rm -it -v ${PWD}:/data ghcr.io/graphs4value/refinery-cli:0.3.0\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["This will let you read input files and generate models in the current directory (", _jsx(_components.code, {
        children: "${PWD}"
      }), ") of your terminal session.\nModule imports (e.g., ", _jsx(_components.code, {
        children: "import some::module."
      }), " to import ", _jsx(_components.code, {
        children: "some/module.refinery"
      }), ") relative to the current directory are also supported."]
    }), "\n", _jsxs(_components.p, {
      children: ["For example, to generate a model based on the file named ", _jsx(_components.code, {
        children: "input.problem"
      }), " in the current directory and write the results into the file named ", _jsx(_components.code, {
        children: "output.refinery"
      }), ", you may run the ", _jsxs(_components.a, {
        href: "#generate",
        children: [_jsx(_components.code, {
          children: "generate"
        }), " subcommand"]
      }), " with"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-shell",
        children: "docker run --rm -it -v ${PWD}:/data ghcr.io/graphs4value/refinery-cli:0.3.0 generate -o output.refinery input.problem\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "If you want Refinery CLI to print its documentation, run"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-shell",
        children: "docker run --rm -it -v ${PWD}:/data ghcr.io/graphs4value/refinery-cli:0.3.0 -help\n"
      })
    }), "\n", _jsxs(_components.h2, {
      id: "generate",
      children: ["The ", _jsx(_components.code, {
        children: "generate"
      }), " subcommand"]
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.code, {
        children: "generate"
      }), " subcommand generates a consistent concrete model from a partial model.\nYou can also use the short name ", _jsx(_components.code, {
        children: "g"
      }), " to access this subcommand."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-shell",
        children: "docker run --rm -it -v ${PWD}:/data ghcr.io/graphs4value/refinery-cli:0.3.0 generate [options] input path\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.code, {
        children: "input path"
      }), " should be a path to a ", _jsx(_components.code, {
        children: ".problem"
      }), " file relative to the current directory.\nDue to Docker containerization, paths ", _jsx(_components.em, {
        children: "outside"
      }), " the current directory (e.g., ", _jsx(_components.code, {
        children: "../input.problem"
      }), ") are not supported."]
    }), "\n", _jsxs(_components.p, {
      children: ["Passing ", _jsx(_components.code, {
        children: "-"
      }), " as the ", _jsx(_components.code, {
        children: "input path"
      }), " will read a partial model from the standard input."]
    }), "\n", _jsxs(_components.p, {
      children: ["By default, the generator is ", _jsx(_components.em, {
        children: "deterministic"
      }), " and always outputs the same concrete model. See the ", _jsx(_components.a, {
        href: "#generate-random-seed",
        children: _jsx(_components.code, {
          children: "-random-seed"
        })
      }), " option to customize this behavior."]
    }), "\n", _jsxs(_components.p, {
      children: ["See below for the list of supported ", _jsx(_components.code, {
        children: "[options]"
      }), "."]
    }), "\n", _jsxs(_components.h3, {
      id: "generate-output",
      children: [_jsx(_components.code, {
        children: "-output"
      }), ", ", _jsx(_components.code, {
        children: "-o"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["The output path for the concretized model, usually a file with the ", _jsx(_components.code, {
        children: ".refinery"
      }), " extension.\nPassing ", _jsx(_components.code, {
        children: "-o -"
      }), " will write the generated model to the standard output."]
    }), "\n", _jsxs(_components.p, {
      children: ["When generating multiple models with ", _jsx(_components.a, {
        href: "#generate-solution-number",
        children: _jsx(_components.code, {
          children: "-solution-number"
        })
      }), ", the value ", _jsx(_components.code, {
        children: "-"
      }), " is not supported and individual solutions will be saved to numbered files.\nFor example, if you pass ", _jsx(_components.code, {
        children: "-o output.refinery -n 10"
      }), ", solutions will be saved as ", _jsx(_components.code, {
        children: "output_001.refinery"
      }), ", ", _jsx(_components.code, {
        children: "output_002.refinery"
      }), ", …, ", _jsx(_components.code, {
        children: "output_010.refinery"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Default value:"
      }), " ", _jsx(_components.code, {
        children: "-"
      }), ", i.e., the solution is written to the standard output."]
    }), "\n", _jsxs(_components.h3, {
      id: "generate-random-seed",
      children: [_jsx(_components.code, {
        children: "-random-seed"
      }), ", ", _jsx(_components.code, {
        children: "-r"
      })]
    }), "\n", _jsx(_components.p, {
      children: "Random seed to control the behavior of model generation."
    }), "\n", _jsxs(_components.p, {
      children: ["The same random seed value and Refinery release will produce the same output model for an input problem.\nModels generated with different values of ", _jsx(_components.code, {
        children: "-random-seed"
      }), " are highly likely (but are not guaranteed) to be ", _jsx(_components.em, {
        children: "substantially"
      }), " different."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Default value:"
      }), " ", _jsx(_components.code, {
        children: "1"
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "generate-scope",
      children: [_jsx(_components.code, {
        children: "-scope"
      }), ", ", _jsx(_components.code, {
        children: "-s"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Add ", _jsx(_components.a, {
        href: "../../language/logic#type-scopes",
        children: "scope constraints"
      }), " to the input problem."]
    }), "\n", _jsx(_components.p, {
      children: "This option is especially useful if you want to generate models of multiple sizes from the same partial model."
    }), "\n", _jsx(_components.p, {
      children: "For example, the command"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-shell",
        children: "docker run --rm -it -v ${PWD}:/data ghcr.io/graphs4value/refinery-cli:0.3.0 generate -s File=20..25 input.problem\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "is equivalent to appending"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-refinery",
        metastring: "title=\"input.problem\"",
        children: "scope File = 20..25.\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["to ", _jsx(_components.code, {
        children: "input.problem"
      }), ".\nThe syntax of the argument is equivalent to the ", _jsx(_components.a, {
        href: "../../language/logic#type-scopes",
        children: _jsx(_components.code, {
          children: "scope"
        })
      }), " declaration, but you be careful with the handling of spaces in your shell.\nAny number of ", _jsx(_components.code, {
        children: "-s"
      }), " arguments are supported. For example, the following argument lists are equivalent:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-shell",
        children: "-scope File=20..25,Directory=3\n-s File=20..25,Directory=3\n-s File=20..25 -s Directory=3\n-s \"File = 20..25, Directory = 3\"\n-s \"File = 20..25\" -s \"Directory = 3\"\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.code, {
        children: "*"
      }), " opeator also has to be quoted to avoid shell expansion:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-shell",
        children: "-s \"File=20..*\"\n"
      })
    }), "\n", _jsxs(_components.h3, {
      id: "generate-scope-override",
      children: [_jsx(_components.code, {
        children: "-scope-override"
      }), ", ", _jsx(_components.code, {
        children: "-S"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Override ", _jsx(_components.a, {
        href: "../../language/logic#type-scopes",
        children: "scope constraints"
      }), " to the input problem."]
    }), "\n", _jsxs(_components.p, {
      children: ["This argument is similar to ", _jsx(_components.a, {
        href: "#generate-scope",
        children: _jsx(_components.code, {
          children: "-scope"
        })
      }), ", but has higher precedence than the ", _jsx(_components.a, {
        href: "../../language/logic#type-scopes",
        children: _jsx(_components.code, {
          children: "scope"
        })
      }), " declarations already present in the input file.\nHowever, you can’t override ", _jsx(_components.code, {
        children: "scope"
      }), " declarations in modules imported in the input file using the ", _jsx(_components.code, {
        children: "import"
      }), " statement."]
    }), "\n", _jsx(_components.p, {
      children: "For example, if we have"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-refinery",
        metastring: "title=\"input.problem\"",
        children: "scope File = 20..25, Directory = 3.\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["in the input file, the arguments ", _jsx(_components.code, {
        children: "-s File=10..12 input.problem"
      }), " will be interpreted as"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-refinery",
        children: "scope File = 20..25, Directory = 3.\nscope File = 10..12.\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["which results in an ", _jsx(_components.em, {
        children: "unsatisfiable"
      }), " problem. If the use ", _jsx(_components.code, {
        children: "-S File=10..12 input.problem"
      }), " instead, the type scope for ", _jsx(_components.code, {
        children: "File"
      }), " is overridden as"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-refinery",
        children: "scope Directory = 3.\nscope File = 10..12.\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["and model generation can proceed as requested. Since we had specified no override for ", _jsx(_components.code, {
        children: "Directory"
      }), ", its type scope declared in ", _jsx(_components.code, {
        children: "input.problem"
      }), " was preserved."]
    }), "\n", _jsxs(_components.p, {
      children: ["Scope overrides do not override additional scopes specified with ", _jsx(_components.a, {
        href: "#generate-scope",
        children: _jsx(_components.code, {
          children: "-scope"
        })
      }), ", i.e., ", _jsx(_components.code, {
        children: "-s File=20..30 -S File=10..25"
      }), " is interpreted as ", _jsx(_components.code, {
        children: "-S File=20..25"
      }), "."]
    }), "\n", _jsxs(_components.h3, {
      id: "generate-solution-number",
      children: [_jsx(_components.code, {
        children: "-solution-number"
      }), ", ", _jsx(_components.code, {
        children: "-n"
      })]
    }), "\n", _jsx(_components.p, {
      children: "The number of distinct solutions to generate."
    }), "\n", _jsxs(_components.p, {
      children: ["Generated solutions are always different, but are frequently not ", _jsx(_components.em, {
        children: "substantially"
      }), " different, i.e., the differences between generated solutions comprise only a few model elements.\nYou’ll likely generate substantially different models by calling the generator multiple times with different ", _jsx(_components.a, {
        href: "#generate-random-seed",
        children: _jsx(_components.code, {
          children: "-random-seed"
        })
      }), " values instead."]
    }), "\n", _jsxs(_components.p, {
      children: ["The generator will create ", _jsx(_components.a, {
        href: "#generate-output",
        children: "numbered output files"
      }), " for each solution found.\nThe generation is considered successful if it finds at least one solution, but may find less than the requested number of solutions if no more exist.\nIn this case, there will be fewer output files than requested."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Default value:"
      }), " ", _jsx(_components.code, {
        children: "1"
      })]
    }), "\n", _jsxs(_components.h2, {
      id: "check",
      children: ["The ", _jsx(_components.code, {
        children: "check"
      }), " subcommand"]
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.code, {
        children: "check"
      }), " subcommand checks a partial model for inconsistencies."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["For ", _jsx(_components.strong, {
          children: "consistent"
        }), " partial models, it has an exit value of ", _jsx(_components.code, {
          children: "0"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["For ", _jsx(_components.strong, {
          children: "inconsistent"
        }), " partial models that contains ", _jsx(_components.code, {
          children: "error"
        }), " logic values, it prints the occurrences of ", _jsx(_components.code, {
          children: "error"
        }), " logic values to the standard output and sets the exit value to ", _jsx(_components.code, {
          children: "1"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["For partial models that can’t be constructed due to ", _jsx(_components.strong, {
          children: "syntax or propagation errors"
        }), ", it prints and error message to the standard output and sets the exit value to ", _jsx(_components.code, {
          children: "1"
        }), "."]
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-shell",
        children: "docker run --rm -it -v ${PWD}:/data ghcr.io/graphs4value/refinery-cli:0.3.0 check [options] input path\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.code, {
        children: "input path"
      }), " should be a path to a ", _jsx(_components.code, {
        children: ".problem"
      }), " or ", _jsx(_components.code, {
        children: ".refinery"
      }), " file relative to the current directory.\nDue to Docker containerization, paths ", _jsx(_components.em, {
        children: "outside"
      }), " the current directory (e.g., ", _jsx(_components.code, {
        children: "../input.problem"
      }), ") are not supported."]
    }), "\n", _jsxs(_components.p, {
      children: ["Passing ", _jsx(_components.code, {
        children: "-"
      }), " as the ", _jsx(_components.code, {
        children: "input path"
      }), " will read a partial model from the standard input."]
    }), "\n", _jsxs(_components.h3, {
      id: "check-concretize",
      children: [_jsx(_components.code, {
        children: "-concretize"
      }), ", ", _jsx(_components.code, {
        children: "-k"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["If you provide this flag, the partial model will be concretized according to the behavior of the ", _jsxs(_components.a, {
        href: "#concretize",
        children: [_jsx(_components.code, {
          children: "concretize"
        }), " subcommand"]
      }), " before checking for inconsistencies.\nYou can use this flag to check whether a partial model can be concretized consistently without having to save the result somewhere."]
    }), "\n", _jsxs(_components.h2, {
      id: "concretize",
      children: ["The ", _jsx(_components.code, {
        children: "concretize"
      }), " subcommand"]
    }), "\n", "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.code, {
        children: "concretize"
      }), " subcommand creates a concrete model by replacing ", _jsx(_components.code, {
        children: "unknown"
      }), " aspects of a partial model with ", _jsx(_components.code, {
        children: "false"
      }), " logic values.\nThe resulting concrete model is the same as the one shown in the ", _jsx(LockIcon, {
        className: "inline-icon",
        "aria-hidden": "true"
      }), " ", _jsx(_components.strong, {
        children: "concrete"
      }), " view in the ", _jsx(_components.a, {
        href: "/learn/tutorials/file-system/#refinery-web-ui",
        children: "Refinery web UI"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["This subcommand is only able to save ", _jsx(_components.em, {
        children: "consistent"
      }), " concrete models.\nIf the result of the concretization is inconsistent, it shows an error with a form similar to the ", _jsx(_components.a, {
        href: "#check",
        children: _jsx(_components.code, {
          children: "check"
        })
      }), " subcommand."]
    }), "\n", _jsx(_components.p, {
      children: "Scope constraints will likely render your partial model inconsistent after concretization if they prescribe multiple nodes to be created. You should the required nodes manually to the model or remove the scope constraints before concretization."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-shell",
        children: "docker run --rm -it -v ${PWD}:/data ghcr.io/graphs4value/refinery-cli:0.3.0 concretize [options] input path\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.code, {
        children: "input path"
      }), " should be a path to a ", _jsx(_components.code, {
        children: ".problem"
      }), " or ", _jsx(_components.code, {
        children: ".refinery"
      }), " file relative to the current directory.\nDue to Docker containerization, paths ", _jsx(_components.em, {
        children: "outside"
      }), " the current directory (e.g., ", _jsx(_components.code, {
        children: "../input.problem"
      }), ") are not supported."]
    }), "\n", _jsxs(_components.p, {
      children: ["Passing ", _jsx(_components.code, {
        children: "-"
      }), " as the ", _jsx(_components.code, {
        children: "input path"
      }), " will read a partial model from the standard input."]
    }), "\n", _jsxs(_components.p, {
      children: ["See below for the list of supported ", _jsx(_components.code, {
        children: "[options]"
      }), "."]
    }), "\n", _jsxs(_components.h3, {
      id: "concretize-output",
      children: [_jsx(_components.code, {
        children: "-output"
      }), ", ", _jsx(_components.code, {
        children: "-o"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["The output path for the concretized model, usually a file with the ", _jsx(_components.code, {
        children: ".refinery"
      }), " extension.\nPassing ", _jsx(_components.code, {
        children: "-o -"
      }), " will write the concretized model to the standard output."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Default value:"
      }), " ", _jsx(_components.code, {
        children: "-"
      }), ", i.e., the model is written to the standard output."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

